<template>
  <div class="container-detail" v-if="loading">
    <div class="detail-header-buttons">
      <v-btn @click="back" style="width: auto !important" class="button-accept">
        <v-icon>mdi-chevron-left</v-icon>
        Вернуться к списку опросов
      </v-btn>

      <v-btn
        v-if="tabs == 0"
        @click="goToEdit"
        style="width: auto !important"
        class="button-action"
      >
        Редактировать
      </v-btn>
      <v-btn
        @click="downloadFile"
        v-if="tabs == 1"
        outlined
        :disabled="!statistics"
        color="var(--app-dark-blue-1) "
        class="button-accept-outlined"
        style="width: auto !important"
      >
        Выгрузить таблицу с результатами
      </v-btn>
    </div>
    <v-tabs v-model="tabs" class="detail-tabs" color="var(--app-dark-blue-1)">
      <v-tab>Детальная информация </v-tab>
      <v-tab> Результаты опроса </v-tab>

      <v-tab-item>
        <div class="detail-main">
          <div class="detail-main-first-container">
            <div class="first-container-box" v-if="item.title">
              <div class="container-box-title">Заголовок</div>
              <div class="container-box-text">
                {{ item.title }}
              </div>
            </div>
            <div class="first-container-box" v-if="item.question">
              <div class="container-box-title">Вопрос</div>
              <div class="container-box-text">
                {{ item.question }}
              </div>
            </div>
            <div class="first-container-box" v-if="item.description">
              <div class="container-box-title">Описание</div>
              <div class="container-box-text">
                {{ item.description }}
              </div>
            </div>
            <div class="first-container-box" v-if="item.dateEnd">
              <div class="container-box-title">Дата завершения</div>
              <div class="container-box-text">
                {{ item.dateEnd | moment("DD.MM.YYYY HH:mm") }}
              </div>
            </div>
            <div
              class="first-container-box"
              v-if="item.answers && item.answers.length > 0"
            >
              <div class="container-box-title">Варианты ответов</div>

              <div
                class="container-box-text"
                v-for="item in item.answers"
                :key="item.id"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
          <div class="detail-main-second-container">
            <div class="second-container-box">
              <div class="container-box-title">Изображение</div>
              <div class="container-box-text">
                Нажмите на изображение, чтобы увидеть его в полном размере
              </div>
            </div>
            <div>
              <v-simple-table v-if="item">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Формат</th>
                      <th class="text-left">Место отображенния</th>
                      <th class="text-left">Для смартфонов</th>
                      <th class="text-left">Для планшетов</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="height: 60px">
                      <td class="text-left">Главное изображение</td>
                      <td class="text-left">Отображается в списке опроса</td>
                      <td class="text-left">
                        <img
                          @click="openDialogImg(item.smartphoneMainImage)"
                          v-if="item.smartphoneMainImage"
                          class="table-img"
                          :src="item.smartphoneMainImage"
                        />
                      </td>
                      <td class="text-left">
                        <img
                          @click="openDialogImg(item.tabletMainImage)"
                          v-if="item.tabletMainImage"
                          class="table-img"
                          :src="item.tabletMainImage"
                        />
                      </td>
                    </tr>
                    <tr
                      v-if="
                        item.smartphoneInternalImage || item.tabletInternalImage
                      "
                      style="height: 60px"
                    >
                      <td class="text-left">Изображение внутри опроса</td>
                      <td class="text-left">Отображается внутри опроса</td>
                      <td class="text-left">
                        <img
                          @click="openDialogImg(item.smartphoneInternalImage)"
                          v-if="item.smartphoneInternalImage"
                          class="table-img"
                          :src="item.smartphoneInternalImage"
                        />
                      </td>
                      <td class="text-left">
                        <img
                          @click="openDialogImg(item.tabletInternalImage)"
                          v-if="item.tabletInternalImage"
                          class="table-img"
                          :src="item.tabletInternalImage"
                        />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <DialogImage v-model="dialogImg" :src="previewImage" />
              <v-divider></v-divider>
            </div>

            <div
              class="second-container-box"
              style="margin-top: 40px"
              v-if="item.isOnlyForAuthorizedUsers || item.toSendPush"
            >
              <div class="container-box-title">
                Параметры публикации и отображения
              </div>
              <div
                class="container-box-onlytext"
                v-if="item.isOnlyForAuthorizedUsers"
              >
                Прохождение только авторизованным пользователям
              </div>
              <div class="container-box-onlytext" v-if="item.toSendPush">
                Рассылка уведомления при публикации опроса
              </div>
            </div>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="detail-statistics" v-if="statistics">
          <div class="statistics-title">Общая статистика</div>
          <div class="statistics-chart">
            <PieChart :chartData="data" :chartOptions="options" />
          </div>
          <div class="statistics-colors-block">
            <div
              class="colors-block-item"
              v-for="(i, index) in statisticsItems"
              :key="index"
            >
              <div :style="` background: ${i.color};`" class="item-color"></div>
              <div class="item-text">{{ i.name }}</div>
            </div>
          </div>
        </div>
        <div class="detail-statistics-empty" v-else>
          <div class="empty-block">
            <div class="empty-block-text">
              <div>Никто не прошел опрос</div>
              <div>Здесь отобразиться общая статистика по опросу</div>
            </div>
            <img class="empty-block-image" src="@/assets/phone.png" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import PieChart from "@/components/main/PieChart.vue";
import FileSaver from "file-saver";

export default {
  components: {
    PieChart,
  },

  data: () => ({
    data: {
      labels: [],
      datasets: [
        {
          label: "Количество голосов",
          data: [],
          backgroundColor: [],
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          displayColors: false,
          titleColor: "rgba(59, 58, 58, 0.682)",
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          borderColor: "rgba(196, 196, 196, 1)",
          borderWidth: 1,
          cornerRadius: 12,
          padding: {
            top: 10,
            bottom: 10,
            left: 10,
            right: 50,
          },
          titleMarginBottom: 7,
          titleFont: {
            size: "14",
            weight: "700",
          },
          bodyFont: {
            size: "20",
            weight: "700",
          },
          callbacks: {
            label: function (tooltipItem) {
              return (
                "Голосов: " + tooltipItem.dataset.data[tooltipItem.dataIndex]
              );
            },
            labelTextColor: function (context) {
              return 'rgba(59, 58, 58, 0.682)';
            },
          },
        },
      },
    },
    item: {},
    dialogImg: false,
    previewImage: null,
    loading: false,
    tabs: 0,
    statistics: false,
    statisticsItems: [],
    colors: [
      "#002882",
      "#33539B",
      "#667EB4",
      "#99A9CD",
      "#CCD4E6",
      "#9BDDFC",
      "#E5F6FF",
      "#58595B",
      "#A9E2FE",
      "#C5C7C8",
      "#78B497",
      "#D6E08D",
      "#F1CC56",
      "#EA6B50",
      "#BE006E",
      "#F3D0E4",
      "#F9E6F1",
      "#BB965A",
      "#C8AC7D",
      "#D7C3A0",
      "#E6D9C3",
    ],
  }),
  methods: {
    openDialogImg(src) {
      this.previewImage = src;
      this.dialogImg = true;
    },
    back() {
      this.$router.push({ name: "Polls" });
    },
    goToEdit() {
      this.$router.push({
        name: "PollEdit",
        params: { id: this.$route.params.id },
      });
    },
    getItem() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV3 + "/poll", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            pollId: this.$route.params.id,
          },
        })
        .then((res) => {
          this.item = res.data;
          this.loading = true;
          if (
            this.item.totalNumberOfVoters &&
            this.item.totalNumberOfVoters > 0
          ) {
            this.getStatistics();
          }
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
          this.loading = true;
        });
    },
    // getStatistics() {
    //   const anwers = JSON.parse(JSON.stringify(this.item.answers));
    //   const newArr = anwers.sort((a, b) => {
    //     return b.numberOfVoters - a.numberOfVoters;
    //   });
    //   this.statisticsItems = newArr
    //     .map((i, index) => {
    //       if (i.numberOfVoters > 0) {
    //         const newObj = {
    //           value: i.numberOfVoters,
    //           name: i.text,
    //           color: this.colors[index],
    //         };
    //         return newObj;
    //       } else {
    //         return "";
    //       }
    //     })
    //     .filter((i) => i);
    //   this.statistics = true;
    // },

    getStatistics() {
      const anwers = JSON.parse(JSON.stringify(this.item.answers));

      const upvotedAnswers = anwers.filter(
        (answer) => answer.numberOfVoters > 0
      );
      const labels = upvotedAnswers.map((answer) => answer.text);
      const amountAnswers = upvotedAnswers.map(
        (answer) => answer.numberOfVoters
      );
      this.data.labels = labels;
      this.data.datasets[0].data = amountAnswers;

      const randomColor = this.shuffle(this.colors);
      this.data.datasets[0].backgroundColor = randomColor;

      this.statistics = true;
    },

    shuffle(array) {
      return array.sort(() => Math.random() - 0.5);
    },
    downloadFile() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV3 + "/poll/statistics/download",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
            params: {
              pollId: this.item.id,
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          FileSaver.saveAs(res.data, `${this.item.title}.xlsx`);
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() {
    this.colors = this.shuffle(this.colors);
    this.getItem();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.container-detail {
  box-sizing: border-box;

  .detail-header-buttons {
    display: flex;
    justify-content: space-between;
    padding: 40px 40px 0px 40px;
    margin-bottom: 32px;
  }

  .detail-tabs {
    margin-left: 16px !important;
  }

  .detail-main {
    display: flex;
    justify-content: space-between;
    margin-top: 54px;
    padding: 0px 40px 0px 32px;

    .detail-main-first-container {
      width: 48%;

      .first-container-box {
        margin-bottom: 40px;

        .container-box-title {
          font-size: 24px;
          font-weight: 600;
        }

        .container-box-text {
          font-size: 18px;
          font-weight: 400;
          word-break: break-word;
        }

        .container-box-text-list {
          .container-box-text-list-item {
            display: flex;
            margin-bottom: 5px;

            .list-item-subtitle {
              font-size: 16px;
              font-weight: 600;
              color: #929292;
              width: 200px;
            }

            .list-item-text {
              font-size: 18px;
              font-weight: 400;
            }
          }
        }
      }
    }

    .detail-main-second-container {
      width: 48%;

      .table-img {
        cursor: pointer;
        height: 38px;
        object-fit: contain;
      }

      .second-container-box {
        width: 100%;
        margin-bottom: 40px;

        .container-box-title {
          font-size: 24px;
          font-weight: 600;
        }

        .container-box-text {
          font-size: 18px;
          font-weight: 400;
          word-break: break-word;
        }

        .container-box-onlytext {
          margin-top: 10px;
        }
      }
    }
  }

  .detail-statistics-empty {
    padding: 40px 40px 40px 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    .empty-block {
      display: flex;
      align-items: center;
      margin-top: 130px;

      .empty-block-text {
        div:first-child {
          font-size: 34px;
          font-weight: 600;
          margin-bottom: 8px;
          color: var(--app-dark-blue-1);
        }

        div:last-child {
          font-size: 20px;
          font-weight: 400;
          color: var(--app-dark-blue-1);
        }
      }

      .empty-block-image {
        // width: 370px;
        height: 370px;
        padding-left: 300px;
      }
    }
  }

  .detail-statistics {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 40px;

    .statistics-title {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 50px;
    }

    .statistics-chart {
      width: 700px;
      height: 400px;
    }

    .statistics-colors-block {
      display: flex;
      flex-wrap: wrap;
      margin-top: 52px;

      // width: 900px;
      .colors-block-item {
        display: flex;
        align-items: center;
        margin: 0px 32px 32px 0px;

        .item-color {
          min-width: 24px;
          max-width: 24px;
          min-height: 24px;
          max-height: 24px;
          border-radius: 4px;
        }

        .item-text {
          margin-left: 16px;
          // max-width: 800px;
          // white-space: nowrap;
          // overflow: hidden;
          // text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
